import {
  beautifyDurationUnit,
  calculateFinancialSupport,
  calculateIntakeName,
  toCurrency,
} from "../../../helpers";
import {
  programDetailsConfig,
  HOUSING_TYPES_MAP,
  PROGRAM_TYPES,
} from "../constants";
import { calcFeeWithScholarshipAndFinancialAid } from "./helperFunctions";

export function parseToProgramPreviewSecondary({ backEndData, branches }) {
  const programPreviewData = {
    otherFees: [],
    details: [],
    detailFiles: [],
  } as any;

  const branchNames = backEndData.branches.map(
    (b) => branches.find((branch) => branch.id === b.branchId)!.name,
  );

  // Program Type -------------------------------------------
  programPreviewData.programType = PROGRAM_TYPES.find(
    (type) => type.id == +backEndData.programType,
  )!.name;

  // Housing Type ---------------------------------------------
  programPreviewData.housingTypes = backEndData.housingTypes.map(
    (type) => HOUSING_TYPES_MAP[type],
  );

  // Intakes --------------------------------------------------
  programPreviewData.intakes = backEndData.intakes.map((intake) => ({
    deadline: intake.deadline,
    startDate: intake.startDate,
    intake: calculateIntakeName(intake.startDate),
  }));

  //  Branches ---------------------------------------------
  programPreviewData.branches = branchNames;

  //  Exams ------------------------------------------------
  programPreviewData.exams = backEndData.exams;

  // Program Duration -------------------------------------------------
  programPreviewData.durationAmount = "" + backEndData.durationAmount;
  programPreviewData.durationUnit = beautifyDurationUnit(
    backEndData.durationAmount,
    backEndData.durationUnit,
    "Program",
  );

  // Tuition Duration-------------------------------------------------
  programPreviewData.tuitionDurationAmount = backEndData.tuitionDurationAmount
    ? "" + backEndData.tuitionDurationAmount
    : "";
  programPreviewData.tuitionDurationUnit = beautifyDurationUnit(
    backEndData.tuitionDurationAmount,
    backEndData.tuitionDurationUnit,
    "Program",
  );

  // Finance --------------------------------------------------
  const currency = +backEndData.currency;
  const tuition = +backEndData.tuition;

  const {
    feeWithCurrency: tuitionWithCurrency,
    calcFeeWithCurrency: calcTuitionWithCurrency,
    scholarshipWithCurrency: tuitionScholarshipWithCurrency,
    financialAidWithCurrency: tuitionFinancialAidWithCurrency,
    hasSupport: hasTuitionSupport,
  } = calcFeeWithScholarshipAndFinancialAid(
    tuition,
    backEndData.hasTuitionScholarship,
    backEndData.tuitionScholarshipType,
    backEndData.tuitionScholarshipAmount,
    backEndData.hasTuitionFinancialAid,
    backEndData.tuitionFinancialAidType,
    backEndData.tuitionFinancialAidAmount,
    currency,
  );

  // Tuition --------------------------------------------------
  programPreviewData.tuition = tuitionWithCurrency;
  // Commission
  const commissionAmount = calculateFinancialSupport(
    tuition,
    true,
    backEndData.commissionType,
    backEndData.commissionAmount,
  );
  programPreviewData.commissionAmount = toCurrency(
    commissionAmount,
    currency,
    " ",
    "code",
  );
  // Accommodation Fees
  if (backEndData.boardingAmount) {
    programPreviewData.boardingAmount = toCurrency(
      backEndData.boardingAmount,
      currency,
      " ",
      "code",
    );
  }

  if (backEndData.homestayAmount) {
    programPreviewData.homestayAmount = toCurrency(
      backEndData.homestayAmount,
      currency,
      " ",
      "code",
    );
  }

  if (backEndData.insuranceAmount) {
    programPreviewData.insuranceAmount = toCurrency(
      backEndData.insuranceAmount,
      currency,
      " ",
      "code",
    );
  }

  programPreviewData.tuitionScholarship = tuitionScholarshipWithCurrency;

  programPreviewData.tuitionFinancialAid = tuitionFinancialAidWithCurrency;

  programPreviewData.calculatedTuition = calcTuitionWithCurrency;

  programPreviewData.hasTuitionSupport = hasTuitionSupport;

  // Other Fees -----------------------------------------------
  let otherFeesSum = 0;
  backEndData.otherFees.forEach((fee) => {
    programPreviewData.otherFees.push({
      name: fee.name,
      amount: toCurrency(fee.amount, currency, " ", "code"),
    });

    otherFeesSum += +fee.amount;
  });

  const {
    feeWithCurrency: otherFeesWithCurrency,
    calcFeeWithCurrency: calcOtherFeesWithCurrency,
    scholarshipWithCurrency: otherFeesScholarshipWithCurrency,
    financialAidWithCurrency: otherFeesFinancialAidWithCurrency,
    hasSupport: hasOtherFeesSupport,
  } = calcFeeWithScholarshipAndFinancialAid(
    otherFeesSum,
    backEndData.hasOtherFeesScholarship,
    backEndData.otherFeesScholarshipType,
    backEndData.otherFeesScholarshipAmount,
    backEndData.hasOtherFeesFinancialAid,
    backEndData.otherFeesFinancialAidType,
    backEndData.otherFeesFinancialAidAmount,
    currency,
  );

  //Details
  programDetailsConfig.forEach((config) => {
    const foundDetail = backEndData.details.find(
      (detail) => detail.type === config.type,
    );

    if (foundDetail) {
      programPreviewData.details.push({
        type: config.type,
        typeName: config.name,
        content: foundDetail.content,
      });
    }
  });

  //Detail Files
  programPreviewData.detailFiles = backEndData.detailFiles!.map((file) => ({
    id: file.fileId,
    name: file.name!,
    size: file.size!,
    path: file.path!,
  }));

  programPreviewData.otherFeesSum = otherFeesWithCurrency;

  programPreviewData.otherFeesScholarship = otherFeesScholarshipWithCurrency;

  programPreviewData.otherFeesFinancialAid = otherFeesFinancialAidWithCurrency;

  programPreviewData.calculatedOtherFees = calcOtherFeesWithCurrency;

  programPreviewData.hasOtherFeesSupport = hasOtherFeesSupport;

  return programPreviewData;
}
